import React from "react";
import "./contact.css";

const Contact = () => {
  return (
    <>
      <br></br>
      <div className="container">
        <div className="contact-jumbo jumbotron">
          <h1 className="text-center">Contact Us</h1>
        </div>
      </div>
    </>
  );
};

export default Contact;
